// Using API Rest
import {userManager} from '@/components/authentication/keycloak.js';

const useAddExpenseReportProof = () => {

  const addExpenseReportProof = async (file) => {
    const formData = new FormData();
    formData.append("expenseReport", file);

// console.log("addExpenseReportProof formData=", formData, "file = ", file)
    try {
      const user = await userManager.getUser();
      const response = await fetch(window.ENV.BACKEND_URL+'/api/secured/users/expense/expenseReportProof', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.access_token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Error uploading expense report proof');
      }

      const data = await response.json();
      return { data, error: null }; // data contains the UUID of the uploaded proof
    } catch (err) {
      return { data: null, error: err.message };
    }
  };

  return { addExpenseReportProof };
};

export default useAddExpenseReportProof;
